module.exports = __webpack_public_path__ + "img/nurse-feature.d54bcfb3.png";